import RentPricingPredictionRequest from '../vo/RentPricingPredictionRequest.js'
import ValuationReport from '../vo/ValuationReport.js'

export const buildPriceReportCommand = (pricingRequest, pricePredictionResponse, userEmail, visitorType, userIsLoggedIn, reportComment, reportSuggestedPrice)=>{
    return new ValuationReport({
        request: pricingRequest, 
        response:pricePredictionResponse, 
        userEmail:userEmail, 
        visitorType:visitorType, 
        isVisitor: !userIsLoggedIn, 
        reportComment:reportComment , 
        reportSuggestedPrice:reportSuggestedPrice
    })
}

export const buildPriceReportUpdateCommand = ({reportComment, minSuggested, maxSuggested})=>{
    return new ValuationReport({
        reportComment: reportComment, 
        reportSuggestedPrice:{ min: minSuggested, max: maxSuggested}
    })
}

export const buildRentPricingPredictionRequestRaw = (latitude, longitude, entryFloor, nrOfFloors, area, condition, parking, balcony, nrOfRooms, isMonthly, placeId, year) => {
    var lat=""
    if(!latitude) return {success:false,message:"missing latitude"}
    else lat = latitude
    
    var lng=""
    if(!longitude) return {success:false,message:"missing longitude"}
    else lng = latitude


    var floors=""
    if(entryFloor && nrOfFloors) floors = entryFloor+"/"+ nrOfFloors

    var rooms
    if(!nrOfRooms) return {success:false,message:"missing nrOfRooms"}
    else rooms = nrOfRooms

    var termType=""
    if(isMonthly)termType="monthly"
    else termType="daily"
    
    //This is optional. The choices is: new, good, renovated, needs renovating, development.
    var c=""
    if(condition){
        if(condition == "new") c = "new";
        if(condition == "good") c = "good";
        if(condition == "renovated") c = "renovated";
        if(condition == "average") c = "good";
        if(condition == "needsReno") c = "needs renovating";
        if(condition == "needsSanReno") c = "needs renovating";
        if(condition == "development") c = "development";
    }

    const request = new RentPricingPredictionRequest({latitude:lat,longitude:lng, area:area, floors:floors, condition: c, balcony:balcony, parking:parking, nrOfRooms:rooms, termType:termType, placeId:placeId, year:year})
    return {success:true, result:request}
}

export const buildRentPricingPredictionRequest = (listing) => {
    try{
        var lat=""
        if(!listing.location.geoCoords[0].lat) return {success:false,message:"missing latitude"}
        else lat = listing.location.geoCoords[0].lat
        
        var lng=""
        if(!listing.location.geoCoords[0].lng) return {success:false,message:"missing longitud"}
        else lng = listing.location.geoCoords[0].lng
    
        // var year=""
        // if(listing.techDet.buildingYear) year = listing.techDet.buildingYear
        var floors=""
        if(listing.techDet.entryFloor && listing.techDet.buildingNrOfFloor) floors = listing.techDet.entryFloor+"/"+listing.techDet.buildingNrOfFloor
        
        var condition=""
        if(listing.techDet.condition){
            if(listing.techDet.condition == "new") condition = "new";
            if(listing.techDet.condition == "good") condition = "good";
            if(listing.techDet.condition == "renovated") condition = "renovated";
            if(listing.techDet.condition == "average") condition = "good";
            if(listing.techDet.condition == "needsReno") condition = "needs renovating";
            if(listing.techDet.condition == "needsSanReno") condition = "needs renovating";
            if(listing.techDet.condition == "development") condition = "development";
        }
        var area=""
        if(listing.techDet.generalArea) area=listing.techDet.generalArea
        var parking=false
        if(listing.techDet.parking.placement)parking=true
        var balcony=false
        if(listing.techDet.balcony.length >0)balcony=true


        var rooms
        if(!listing.techDet.nrOfRooms) return {success:false, message:"missing nrOfRooms"}
        else rooms=listing.techDet.nrOfRooms

        var termType = "monthly"

        var placeId
        if(listing.googLocation) placeId = listing.googLocation.placeId

        // const request = new RentPricingPredictionRequest(lat,lng, area, floor, condition, balcony, parking, rooms, termType, null, null)
        const request = new RentPricingPredictionRequest({latitude:lat,longitude:lng, area:area, floors:floors, condition: condition, balcony:balcony, parking:parking, nrOfRooms:rooms, termType:termType, placeId:placeId})

        return {success:true, result:request}
    }catch(err){
        return {success:false, result:""}
    }

}


// WEBPACK FOOTER //
// ./src/pricing/factory/pricingFactory.js